var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38,
    height: 38,
    viewBox: "0 0 900 900",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 450 450)",
    id: "463888f9-ea93-4fb3-80d1-55e68d83821a"
  }, /*#__PURE__*/React.createElement("rect", {
    vectorEffect: "non-scaling-stroke",
    x: -450,
    y: -450,
    rx: 0,
    ry: 0,
    width: 900,
    height: 900,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255, 255, 255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(Infinity NaN NaN Infinity 0 0)",
    id: "da725cd7-b30f-49bd-885c-c39ba40948c8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(27.18 0 0 27.18 450 450)",
    id: "89a44f39-7d8f-4ae1-b499-bdf69f64a3f1"
  }, /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-44.25, -19.29)",
    d: "M 37.2266 25 L 36.0859 21.8281 L 31.7188 21.8281 L 30.6016 25 L 28.6328 25 L 32.9062 13.5312 L 34.9375 13.5312 L 39.2109 25 L 37.2266 25 Z M 35.5938 20.2188 L 34.5234 17.1094 C 34.4453 16.901 34.3359 16.5729 34.1953 16.125 C 34.0599 15.6771 33.9661 15.349 33.9141 15.1406 C 33.7734 15.7812 33.5677 16.4818 33.2969 17.2422 L 32.2656 20.2188 L 35.5938 20.2188 Z M 45.5781 15.0156 C 44.5052 15.0156 43.6615 15.3958 43.0469 16.1562 C 42.4323 16.9167 42.125 17.9661 42.125 19.3047 C 42.125 20.7057 42.4193 21.7656 43.0078 22.4844 C 43.6016 23.2031 44.4583 23.5625 45.5781 23.5625 C 46.0625 23.5625 46.5312 23.5156 46.9844 23.4219 C 47.4375 23.3229 47.9089 23.1979 48.3984 23.0469 L 48.3984 24.6484 C 47.5026 24.987 46.487 25.1562 45.3516 25.1562 C 43.6797 25.1562 42.3958 24.651 41.5 23.6406 C 40.6042 22.625 40.1562 21.1745 40.1562 19.2891 C 40.1562 18.1016 40.3724 17.0625 40.8047 16.1719 C 41.2422 15.2812 41.8724 14.599 42.6953 14.125 C 43.5182 13.651 44.4844 13.4141 45.5938 13.4141 C 46.7604 13.4141 47.8385 13.6589 48.8281 14.1484 L 48.1562 15.7031 C 47.7708 15.5208 47.362 15.362 46.9297 15.2266 C 46.5026 15.0859 46.0521 15.0156 45.5781 15.0156 Z M 59.8672 25 L 57.9922 25 L 57.9922 19.8516 L 52.7266 19.8516 L 52.7266 25 L 50.8594 25 L 50.8594 13.5781 L 52.7266 13.5781 L 52.7266 18.25 L 57.9922 18.25 L 57.9922 13.5781 L 59.8672 13.5781 L 59.8672 25 Z",
    strokeLinecap: "round",
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(38, 38, 38)",
      fillRule: "nonzero",
      opacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAch);
export default __webpack_public_path__ + "static/media/ach.ebcac7f4c954a087b346fd0ef4dcef07.svg";
export { ForwardRef as ReactComponent };